// axios nao pega a autorizacao, nao dá para usar 
// estudar se for o caso
//import axios from "axios"
import { toastr } from "react-redux-toastr"
import api from "../../../services/api"

import axios from "axios"
import Baseurlaxios from "../../../services/baseurlaxios"

import BaseurlApi from "../../../services/baseurlapi"

export function getData(codigoPuxada) {

    return (dispatch) => {
        axios.get(`${BaseurlApi}/GetProductCombo?codigoPuxada=${codigoPuxada}`, {
            //withCredentials: true,
            // auth: {
            //     username: 'usuario',
            //     password: 'password'
            // },

            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/x-www-form-urlencoded"
            },
        })
            .then(response => {
                dispatch({
                    type: "GET_DATA_PRDCMB",
                    payload: response
                })

            })
            .catch(error => {
                toastr.error("Erro prdCmbActions getData: " + error)
            })
    };
}

export function enviaRegistros(arraycodCatIte, codpuxada, usuario) {

    return (dispatch) => {
        api.post(`/Tb_Log_Envio_prdcmb/IncluiLogPrdCmb?CodPuxada=${codpuxada}&Usuario=${usuario}`, {
            "ArrayCodCatite": arraycodCatIte
        }
        )
            .then(response => {
                if (response.status === 200) {
                    // toastr.success("Enviada a solicitação com sucesso, o será realizado em fila processamentos")
                }
                else {
                    toastr.warning("Reposta da API: " + response.data)
                }

                dispatch([getData(0)])
                dispatch([getData(codpuxada)])
            })
            .catch(error => {
                toastr.error("Erro prdcmbActions enviaRegistros: " + error.statusText)
            })
    }
}

export function getDataTdsRevendas() {
    return (dispatch) => {
        axios.get(`${Baseurlaxios}/Tb_Dist/TodosDist`, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/x-www-form-urlencoded"
            },
        })
            .then(response => {
                dispatch({
                    type: "GET_DATA_LSTRVD",
                    payload: response
                })
            })
            .catch(error => {
                toastr.error("Erro prdCmbActions getDataTdsRevendas: " + error)
            })
    };
}